import { useMemo } from 'react';
import css from './index.module.scss';
import { DataGrid, NoDocumentPlaceholder } from '@components/common';
import { IconNode, Typography } from '@components/base';
import { openDocumentSignedLink, sanitizeValue } from '@helpers/utils';
import Images from '@assets/images';
import {
  ProductIndividualStates,
  SupplierProductDocuments
} from '@pages/product/product-individual';

interface ISupplierDocumentsTabProps {
  productState: ProductIndividualStates;
}

const SupplierDocumentsTab = (props: ISupplierDocumentsTabProps) => {
  const { productState } = props;
  const { supplierProductDocuments } = productState;

  if (supplierProductDocuments.length == 0) {
    return <NoDocumentPlaceholder title="No Product Documents Added Yet" />;
  }

  return (
    <div className={css.mainWrapper}>
      {(supplierProductDocuments || []).map((supplier: SupplierProductDocuments, index: number) => {
        const [documentColumn, documentData] = useMemo(() => {
          const column: Array<any> = [
            {
              Header: 'Document Name',
              accessor: 'document_name'
            },
            {
              Header: 'Product Grade',
              accessor: 'product_grade'
            },
            {
              Header: 'Document Type',
              accessor: 'document_type'
            },
            {
              Header: '',
              accessor: 'document_object',
              Cell: (props: any) => {
                const { value } = props;
                return (
                  <div className={css.actionWrapper}>
                    <IconNode
                      src={Images.eyeRed}
                      alt="Download"
                      onClick={() => {
                        if (value.document_name) {
                          openDocumentSignedLink(value.document_object);
                        }
                      }}
                    />
                  </div>
                );
              }
            }
          ];

          const rows: Array<any> = [];

          supplier.supplier_product_grade.forEach((grade: any) => {
            if (
              grade.supplier_product_grade_document &&
              grade.supplier_product_grade_document.length > 0
            ) {
              grade.supplier_product_grade_document.forEach((doc: any) => {
                rows.push({
                  product_grade: sanitizeValue(grade.product_grade),
                  document_name: sanitizeValue(doc.document_name),
                  document_type: sanitizeValue(doc.document_type),
                  document_object: doc
                });
              });
            }
          });

          return [column, rows];
        }, [supplier]);
        return (
          <div key={index} className={css.documentWrapper}>
            <Typography
              variant="h5"
              className={css.supplierName}
              onClick={() => {
                window.open(`/supplier/${supplier.supplier_id}`, '_blank');
              }}>
              {supplier.supplier_name}
            </Typography>
            <DataGrid columns={documentColumn} data={documentData} />
          </div>
        );
      })}
    </div>
  );
};

export default SupplierDocumentsTab;
